import React from 'react'
import { Button, Container } from 'react-bootstrap';
import styles from './home.module.scss';
import { Link } from 'react-router-dom';

const HomeSoftwareCallout = () => {
    return (<>
        <div className={styles.light}>
            <Container className={styles.mainContainer + ' ' + 'centerText'}>
                <h3>Put the Quality Indicators to work for your organization</h3>
                <Link
                                className="btn btn-primary"
                                role="button"
                                to="/software"
                            >
                                Get the AHRQ QI Software
                            </Link>
            </Container>
        </div>
    </>)
}

export default HomeSoftwareCallout;